<script setup>
import DesktopHeader from './DesktopHeader.vue'
import DesktopSidebar from './DesktopSidebar.vue'
import MobileBottomNav from './MobileBottomNav.vue'
import MobileHeader from './MobileHeader.vue'
import FeedbackDialog from '@/components/FeedbackDialog.vue'
</script>

<template>
  <div class="app-shell">
    <DesktopSidebar />

    <div class="main-area">
      <DesktopHeader />
      <MobileHeader />

      <main class="page-content">
        <RouterView />
      </main>

      <MobileBottomNav />
    </div>

    <FeedbackDialog />
  </div>
</template>

<style scoped>
.app-shell {
  --primary: #4b43d1;
  --primary-light: #eeefff;
  --border: #d9d9e7;
  --text: #202124;
  --text-secondary: #5f6070;
  --background: #fbfbfd;

  min-height: 100vh;
  background: var(--background);
  color: var(--text);
}

.main-area {
  min-width: 0;
  min-height: 100vh;
  margin-left: 274px;
}
.page-content {
  min-height: calc(100vh - 66px);
}

@media (max-width: 1023px) {
  .main-area {
    margin-left: 0;
  }
  .page-content {
    min-height: calc(100vh - 64px);
    padding-bottom: 76px;
    min-width: 0;
  }
}
</style>
